import Vue from 'vue';
import Vuex from 'vuex';
import Legacy from '@/core/legacy'
import { mutations } from '@/store/types';

// Add Vuex to Vue instance
Vue.use(Vuex);

// Create new Vuex instance
const store =  new Vuex.Store({

  state: {
    showOverlay: false,
    noOverlayDelay: false,
    showMenu: false,
    messages: [],
  },

  mutations: { 

    /*** LEGACY MUTATIONS (Called from legacy js via the window.App.store.commit function) ***/
    [mutations.SHOW_OVERLAY]( state, {show, noOverlayDelay}) {
      if ( typeof show === "boolean" ) {
        state.showOverlay = show
        state.noOverlayDelay = noOverlayDelay
      } else {
        state.showOverlay = false
        state.noOverlayDelay = false
      }  
    },

    [mutations.SHOW_MENU]( state, show ) {
      if ( typeof show === "boolean" ) {
        state.showMenu = show
      } else {
        state.showMenu = false
      }
      Legacy.showMenu( state.showMenu )
    },

    /*** VUE ONLY MUTATIONS ***/
    [mutations.CLEAR_MESSAGES]( state ) {
      state.messages = [];
    },

    [mutations.ADD_MESSAGE]( state, message ) {
      if (!message || !message.text) {
        return;
      }
      
      message.type = message.type || "error";
      state.messages.push(message);
    },

    [mutations.DELETE_MESSAGE]( state, index ) {
      if (state.messages.length > index) {
        state.messages.splice(index, 1);
      }
    },

  },
  actions: { },
  getters: { },
  modules: { },
})

// Add store to global variable to places in RecTrac framework we might need it
if ( window.App && !window.App.store ) {
  window.App.store = store
}

// This is needed here so that global registered components have access to $store.
Vue.prototype.$store = store;

export default store